"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JwtAccessClaimsSchema", {
    enumerable: true,
    get: function() {
        return JwtAccessClaimsSchema;
    }
});
const _zod = require("zod");
const JwtAccessClaimsSchema = _zod.z.object({
    /** subject — user id */ sub: _zod.z.string().min(1),
    /** tenant id, or in EMR the clinic id (ADR-0004 §5) */ tid: _zod.z.string().min(1),
    /** rls hints (role names). Empty array if Phase 3 hasn't populated yet. */ rls: _zod.z.array(_zod.z.string()),
    /**
   * MFA-satisfied flag. True when the access token was minted after a
   * successful MFA verify (or when the user has no MFA factor enrolled).
   */ mfa: _zod.z.boolean(),
    /** issued-at (seconds since epoch) */ iat: _zod.z.number().int().nonnegative(),
    /** expires-at (seconds since epoch) */ exp: _zod.z.number().int().nonnegative()
});
